import { render, staticRenderFns } from "./RateSkeleton.vue?vue&type=template&id=21ce8ee8&"
import script from "./RateSkeleton.vue?vue&type=script&lang=js&"
export * from "./RateSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./RateSkeleton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports